import { pushToast } from '../store/toastStore';
// Transient action feedback only — toasts are NOT recorded in the notification
// panel (the user already saw them). Durable account events reach the panel via
// their own backend notifications.
export const message = {
  success: (msg: string) => pushToast('success', msg),
  warning: (msg: string) => pushToast('warning', msg),
  error:   (msg: string) => pushToast('error', msg),
  info:    (msg: string) => pushToast('info', msg),
};
